import { validate } from './validation/config'
import { demoConfig } from './customer configs/demo'
import joi from 'joi'

// Customer Configs
import { configMock as bestpellets } from './customer configs/bestpellets'
import { configMock as hamburglifte } from './customer configs/hamburglifte'
import { configMock as strahlenzentrum } from './customer configs/strahlenzentrum'
import { configMock as raumundnatur } from './customer configs/raumundnatur'
import { configMock as bts } from './customer configs/bts'
import { configMock as stein } from './customer configs/stein'

// Select config
export const configMock = strahlenzentrum

declare global {
  interface Window {
    cfa: IUserConfig
  }
}

// Remove `mock` when data is moved to html file script tag.
// mock in read() determines which config should be build
const read = (): Readonly<IUserConfig> =>
  Object.freeze((window && window.cfa) || configMock)

export const validatedConfig: Readonly<joi.ValidationResult> = validate(read())
export const validatedDemoConfig: Readonly<joi.ValidationResult> = validate(
  demoConfig
)
